import React, {FunctionComponent, Fragment} from 'react';
import {IBuilding} from '../../../../types/IBuilding';

interface IBuildingsOptions {
    buildings: IBuilding[];
    currentBuilding?: IBuilding | null;
}

const BuildingsOptions: FunctionComponent<IBuildingsOptions> = ({buildings, currentBuilding}) => {
    if(!currentBuilding) return null;
    return (
        <Fragment>
            <option
                key={currentBuilding.id}
                value={currentBuilding.id}
            >
                {currentBuilding.name}
            </option>
            {
                buildings.map(b => {
                    if(b.id === currentBuilding?.id) return null;
                    return (
                        <option
                            key={b.id}
                            value={b.id}
                        >
                            {b.name}
                        </option>
                    )
                })
            }
        </Fragment>
    )
};


export default BuildingsOptions;
